{{#if interface.hasResetAndOtherPorts}}
virtual task initialize_signals();
endtask
{{/if}}
